var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M4.3,4.78v8.553A3.3,3.3,0,0,0,7.336,16.66l.214.007h5.739A1.955,1.955,0,0,1,11.45,18H6.9A3.951,3.951,0,0,1,3,14V6.667A2,2,0,0,1,4.3,4.78ZM14.05,2A1.975,1.975,0,0,1,16,4v9.333a1.976,1.976,0,0,1-1.95,2H7.55a1.975,1.975,0,0,1-1.95-2V4A1.975,1.975,0,0,1,7.55,2Zm0,1.333H7.55A.658.658,0,0,0,6.9,4v9.333A.659.659,0,0,0,7.55,14h6.5a.659.659,0,0,0,.65-.667V4A.659.659,0,0,0,14.05,3.333Z",
    transform: "translate(-3 -2)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9e2e7493cba7911eb277a56b8232d062.svg";
export { ForwardRef as ReactComponent };